import { RouterPaths } from "../routerPaths";
import { importPages } from "../lazyRoute";

const studentsRoutes = [
    {
        path: RouterPaths.STUDENTS,
        element: importPages.Students,
    },
    {
        path: RouterPaths.STUDYPAYMENTOPTIONS,
        element: importPages.StudyPaymentOptions,
    },

    {
        path: RouterPaths.STUDENTSOVERVIEW,
        element: importPages.StudentsOverview,
    },
    {
        path: RouterPaths.STUDENTSSETTINGS,
        element: importPages.StudentsSettings,
    },
];

export default studentsRoutes;
